import PPLogo from '@propertypal/shared/src/resources/logos/PropertyPalLogo.svg?url';
import PageWrapper from '@propertypal/web-ui/src/layout/PageWrapper';
import { Text } from '@propertypal/web-ui/src/typography';
import Link from 'next/link';
import React from 'react';
import { useTheme } from 'styled-components';
import { displayConsentUi } from '../../services/ads/cmp';
import { Container } from './copyright-and-policy-links/CopyrightAndPolicyLinks.style';
import { FooterContainer, FooterInner, FaqFooterLinks, LinksColumn, Logo } from './Footer.style';
import SocialLinks from './social-links/SocialLinks';

const FaqFooter: React.FunctionComponent = () => {
  const theme = useTheme();
  return (
    <FooterContainer className="hide-print" pb={30}>
      <PageWrapper>
        <FooterInner data-testid="faq-footer">
          <FaqFooterLinks>
            <LinksColumn>
              <Link aria-label="Home Page" href="/" prefetch={false}>
                <Logo src={PPLogo.src} alt="PropertyPal Logo" />
              </Link>
            </LinksColumn>
            <LinksColumn>
              <Link href="/" prefetch={false}>
                PropertyPal.com
              </Link>

              <Link href="/privacy" prefetch={false}>
                Privacy Policy
              </Link>

              <Link href="/cookie-policy" prefetch={false}>
                Cookie Policy
              </Link>
            </LinksColumn>

            <LinksColumn>
              <Link href="/terms" prefetch={false}>
                Terms &amp; Conditions
              </Link>
              <Link href="/hosting-terms" prefetch={false}>
                Hosting Terms
              </Link>
              <button onClick={displayConsentUi} type="button">
                Change privacy settings
              </button>
            </LinksColumn>
          </FaqFooterLinks>
          <SocialLinks />
        </FooterInner>
      </PageWrapper>

      <PageWrapper>
        <Container data-testid="footer-copyright">
          <Text fontSize={14} color={theme.textDark}>
            &copy; Copyright <b>PropertyPal.com</b> 2007-{new Date().getFullYear()}
          </Text>
        </Container>
      </PageWrapper>
    </FooterContainer>
  );
};

export default FaqFooter;
